export const appData = {
    year: new Date().getFullYear()
}
